<template>
    <v-card class="pa-4">
        <v-form ref="form" @submit.prevent="check_validation(question)">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL()" aria-hidden="true" translate="no">{{$t("закрыть")}}</v-icon>
            <v-card-title class="display-1 mb-4">{{$t("Задать вопрос")}}</v-card-title>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Тема вопроса")}} *</div>
                    <v-select
                        v-model.trim="theme"
                        :class="{ 'form-group--error': $v.theme.$error }"
                        :items="themes"
                        solo
                        attach=".v-select.input"
                        append-icon=""
                        :placeholder="theme ? undefined : $t('Выберите тему')"
                        class="input"
                        @change="question_theme($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
            </v-layout>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Опишите Ваш вопрос")}} *</div>
                    <textareaBase :value="que" :placeholder="$t('Введите текст')" rows="4"
                                  :class="{ 'form-group--error': $v.que.$error }"
                                  @change="question_text($event.target.value)"
                    />
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">{{$t("Отправить")}}</buttonRed>
                    <div class="grey-text">{{$t("* - поля, обязательные для заполнения")}}</div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import {validationMixin} from 'vuelidate';
import buttonRed   from '@/components/ui/buttons/button_red';
import textareaBase from '@/components/ui/inputs/base/textarea';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    buttonRed,
    textareaBase,
  },
  mixins     : [validationMixin],
  validations: {
    theme: {
      required,
    },
    que: {
      required,
    },
  },
  data() {
    return {
      errors  : false,
      theme   : '',
      que     : '',
      question: {
        question_theme: 'null',
        question_text : '',
      },
    };
  },
  computed: {
    ...mapGetters('faq/questions', [
      'themes',
    ]),
  },
  methods: {
    ...mapMutations('faq/questions', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('contact/requests', [
      'ask_question',
    ]),
    check_validation(que) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.ask_question(que);
        this.errors = false;
      }
    },
    question_theme(ev) {
      this.theme = ev;
      this.$v.theme.$touch();
      this.question.question_theme = ev;
    },
    question_text(ev) {
      this.que = ev;
      this.$v.que.$touch();
      this.question.question_text = ev;
    },
  },


};
</script>

<style>

</style>
